import GlobalClaims from './GlobalClaims';

export default GlobalClaims;
